import { render, staticRenderFns } from "./preference.vue?vue&type=template&id=60253401&scoped=true&"
import script from "./preference.vue?vue&type=script&lang=js&"
export * from "./preference.vue?vue&type=script&lang=js&"
import style0 from "./preference.vue?vue&type=style&index=0&id=60253401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60253401",
  null
  
)

export default component.exports